import _ from "lodash";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Route, Switch, Link, useParams, useRouteMatch } from "react-router-dom";
import { Error400 } from "views/pages";
import { PageTitle } from "components/standart";
import Form from "./Form";

import { adminAPI } from "redux/api";
import { apiUrls } from "../init";
const { api } = adminAPI.actions;

const BrandInfo = (props) => {
  const { url, path } = useRouteMatch();

  const params = useParams();

  const [faq, setFaq] = useState(null);
  const [notFound, setNotFound] = useState(false);

  const { breadCrumbs, faqForm } = props;

  if (faq) {
    breadCrumbs.push({
      title: faq.title,
      url,
      actions: [
        <Link to={faqForm(faq)}>
          <i className="fa fa-edit" />
        </Link>,
      ],
    });
  }

  useEffect(() => {
    const onSuccess = (body) => {
      setFaq(body);
    };
    const onFailure = ({ status }) => {
      setNotFound(404 === status);
    };

    props.getFaq({ params }, { onSuccess, onFailure });
  }, []);

  return (
    <>
      {notFound && <Error400 />}

      {faq && (
        <Switch>
          <Route exact path={`${path}`}>
            <div>
              <PageTitle {...breadCrumbs} />

              <div>faq data</div>
            </div>
          </Route>

          <Route exact path={`${path}/form`}>
            <Form {...{ breadCrumbs, faq, setFaq }} />
          </Route>

          <Route component={Error400} />
        </Switch>
      )}
    </>
  );
};

export default connect(null, {
  getFaq: api.get(apiUrls.faqInfo),
})(BrandInfo);
